import { Link as RouterLink } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import { Section } from './Section';
import { PRICING } from './copy';

const HEADING_ID = 'pricing-title';

export function Pricing() {
  return (
    <Section id={PRICING.id} labelledBy={HEADING_ID} eyebrow={PRICING.eyebrow} title={PRICING.title}>
      <Typography sx={{ color: 'var(--ink-muted)', maxWidth: '60ch' }}>{PRICING.body}</Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 4 }}>
        <Button
          component={RouterLink}
          to={PRICING.primary.to}
          variant="contained"
          size="large"
          sx={{ minHeight: 44, alignSelf: { xs: 'stretch', sm: 'flex-start' } }}
        >
          {PRICING.primary.label}
        </Button>
        <Button
          href={PRICING.secondary.to}
          variant="outlined"
          size="large"
          sx={{
            minHeight: 44,
            alignSelf: { xs: 'stretch', sm: 'flex-start' },
            borderColor: 'var(--outline-strong)',
            color: 'var(--ink)',
            '&:hover': {
              borderColor: 'var(--outline-strong)',
              backgroundColor: 'var(--bg-elevated)',
            },
          }}
        >
          {PRICING.secondary.label}
        </Button>
      </Stack>
    </Section>
  );
}
